import endpoints from "hooks/api/endpoints";
import useApiGet, { UseApiGetOptions } from "hooks/api/useApiGet";
import IndividualItemResponse from "types/IndividualItemResponse";
import ProjectDto from "types/ProjectDto";

export default function useGetProjectBySlug(
  slugId?: string,
  options?: UseApiGetOptions,
) {
  const url = slugId ? endpoints.getProjectBySlug(slugId) : null;

  const { result, ...rest } = useApiGet<IndividualItemResponse<ProjectDto>>(
    url,
    options,
  );

  return { project: result?.data, ...rest };
}
